import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, RouterModule } from '@angular/router';
import { BillService } from './bill.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { catchError, switchMap, tap, timer } from 'rxjs';
import { of } from 'rxjs';
import { IBillData } from './modal';
import { BillComponent } from './bill/bill.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, RouterModule, BillComponent],
  providers: [BillService], // Add BillService here
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  billData: IBillData | null = null;
  loading: boolean = true;
  submitting: boolean = false;
  polling: boolean = false;
  error: string | null = null;
  success: boolean = false;
  successMessage: string | null = null;

  formData = {
    amount: '',
    name: '',
    phone: '',
    description: ''
  };

  billId: string = ''; // Default bill ID for testing

  constructor(
  ) { }

  ngOnInit(): void {

  }



}
